import { render, staticRenderFns } from "./TruncatedText.vue?vue&type=template&id=3ae14a7a&scoped=true&"
import script from "./TruncatedText.vue?vue&type=script&lang=ts&"
export * from "./TruncatedText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae14a7a",
  null
  
)

export default component.exports